export const AdCenterPage = {
  Default: 0,
  Ads: 1,
  Keyword: 2,
  Campaign: 3,
};
